import CityPageTemplate from "../city-template/CityPageTemplate";
import { louisvilleConfig } from "./data";

export default function LouisvillePage() {
  return <CityPageTemplate config={louisvilleConfig} />;
}